import contentEngineApi from './content-engine';
import identityApi from './identity';

export default {
    [contentEngineApi.reducerPath]: contentEngineApi.reducer,
    [identityApi.reducerPath]: identityApi.reducer,
};
